// JavaScript Document
//components/configuration/standard/forms/FlashTiming.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Display from '../../display/Display';
import displayVariant from '../displayVariant';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  timingCard: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
	margin: 5,
  },
	//advancedCard : {
	//	margin: theme.spacing(1),
	//},
	/*
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
	},
	*/
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap: "wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
	advancedContentVertical: {
		display: "flex",
		alignItems:"stretch",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap"
	},
	detailsVerticalCenter: {
		display: "flex",
		alignItems:"center",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap",
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
}));

export default function FlashTiming(props) {
  	const classes = useStyles();
	//inherited variables
  	const {id, sign, settings, onChange, message} = props;
	//locally stored/copied variables
	//const [token, setToken] = React.useState(0);
	const [cid, setCid] = React.useState(0);
	const [msgid, setMsgid] = React.useState(84);
	const [pixels, setPixels] = React.useState("000011100100000011100100010000,000100010100000100010100010000,000100000100000100010101010000,000100000100000100010101010000,000011100100000100010101010000,000000010100000100010101010000,000000010100000100010101010000,000100010100000100010101010000,000011100111110011100011100000,000111100011100100010100010000,000100010100010100010100010000,000100010100010101010110010000,000100010100010101010101010000,000100010100010101010100110000,000100010100010101010100010000,000100010100010101010100010000,000100010100010101010100010000,000111100011100011100100010000,");
	//local state varialbes user will change
	const [timing, setTiming] = React.useState({
		on: 500,
		off: 500,
		period: 4,
		cycles: 4
	});

	//display variant renderer
	const dv = displayVariant(sign);

	//choice options
	const choices = [{
		label: 'Slow',
		on: 500,
		off: 500,
		period: 4
	}, {
		label: 'Balanced',
		on: 250,
		off: 250,
		period: 4
	}, {
		label: 'Fast',
		on: 100,
		off: 100,
		period: 3
	}];
	
	
	//find choice
	const getChoice = () => {
		return choices.findIndex(
			(choice) => choice.on === timing.on 
				&& choice.off === timing.off 
				&& choice.period === timing.period);
	}
	
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(
			//inherited config ID is null
			cid === 0 || 
			cid === undefined || 
			cid === null || 
			cid === "0" || 
			//inherited daysetting has changed
			cid !== id 
			//updated from server
			//|| loadedToken != token
		) {
			//console.log('config has changed');
			setCid(id);
			let myTiming = Object.assign(timing, settings);
			myTiming.cycles = (myTiming.period * 1000) / (parseInt(myTiming.on) + parseInt(myTiming.off));
			setTiming(myTiming);
			if(message.id){
				setMsgid(message.id);
			}
			if(message.pixel_map){
				setPixels(message.pixel_map);
			} else {
				setPixels(false);
			}
			//setMyConfig(config);
			//setToken(loadedToken);
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//Update parent on timing changes
	React.useEffect(() => {
		if(onChange){
			console.log('Updating parent');
			onChange(timing);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timing])
	
	//Choice button click
	const handleSelectChoice = (choiceNum) => {
		let newTiming = Object.assign({}, choices[choiceNum]);
		newTiming.cycles = (newTiming.period * 1000) / (parseInt(newTiming.on) + parseInt(newTiming.off));
		setTiming(newTiming);
	}
	
	const limits = {
		on: 127500,
		off: 127500,
		period: 255,
		cycles: 255
	}
	
	//handle change timing value
	const handleChangeValue = (e) => {
		let setting = e.target.name;
		let value = parseInt(e.target.value);
		let newTiming = Object.assign({}, timing);
		
		//clean the value
		if(isNaN(value) || value < 0){
			value = 0;
		} else if(value > limits[setting]){
			value = limits[setting];
		}
		newTiming[setting] = value;
		if(setting === 'cycles'){
			//console.log("changing cycles");
			newTiming.period = Math.ceil((parseInt(newTiming.on) + parseInt(newTiming.off)) * value / 1000);
		} else {
			newTiming.cycles = Math.round((newTiming.period * 1000) / (parseInt(newTiming.on) + parseInt(newTiming.off)));
		}
		setTiming(newTiming);
	}
	
	const renderDisplay = () => {
		return (
			<Display id={msgid} timing={timing} scale={5} splitVertical={dv.size.split} width={dv.size.width} height={dv.size.height} pixel_map={dv.extract(pixels)}/>
		);
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader title="Flash Timing" />
	  		<CardContent className={classes.detailsVerticalCenter}>
				{renderDisplay()}
				<Box className={classes.advancedContent}>
					<ButtonGroup orientation="vertical">
						{choices.map((choice, i) => (
							<Button
								key={i}
								variant={getChoice() === i ? "contained" : "outlined"}
								onClick={(e) => {handleSelectChoice(i)}}
							>{choice.label}</Button>
						))}
						<Button
							variant = {getChoice() === -1 ? "contained" : "outlined"}
						>Custom</Button>
					</ButtonGroup>
					<Box className={classes.detailsVerticalCenter}>
	  					<TextField 
							id="on" 
							name="on"
							label="On"
							value={timing.on.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:'127500', step:'50', style: {textAlign:'center'}}}
						/>
						<TextField 
							id="off" 
							name="off"
							label="Off"
							value={timing.off.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:'127500', step:'50', style: {textAlign:'center'}}}
						/>
					</Box>
					<Box className={classes.detailsVerticalCenter}>
						<TextField 
							id="period" 
							name="period"
							label="Duration"
							value={timing.period.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:'255', step:'1', style: {textAlign:'center'}}}
						/>
						<TextField 
							id="cycles" 
							name="cycles"
							label="Cycles"
							value={timing.cycles.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:'255', step:'1', style: {textAlign:'center'}}}
						/>
					</Box>
					
				</Box>
	  		</CardContent>
	  	</Card>
  );
}
